export default "__VITE_ASSET__Cs8c2Yhv__"